import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyOfferSmall() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const duration = 3000; // 3 seconds for a very "slow" feel
    const start = window.scrollY;
    const targetPosition = target.getBoundingClientRect().top + start - 20;
    const startTime = performance.now();
    const animateScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic function for a smoother finish
      const ease = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, start + (targetPosition - start) * ease);
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };
    requestAnimationFrame(animateScroll);
  };
  return <AnimatePresence data-id="element-269">
      {isVisible && <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -50,
      opacity: 0
    }} className="fixed top-0 right-0 z-[9999] p-1" data-id="element-270">
          <button onClick={scrollToPricing} className="bg-[#90EE90] hover:bg-[#7CCD7C] text-[#0f1711] font-black py-1 px-3 rounded-bl-lg shadow-lg flex items-center gap-2 group transition-colors border-l border-b border-[#1a2e1a]/10 text-[9px] uppercase tracking-tighter" data-id="element-271">
            <span data-id="element-272">VER OFERTA</span>
            <ArrowRight className="w-2.5 h-2.5 group-hover:translate-x-0.5 transition-transform" data-id="element-273" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}